const colorAttributesTransform = (gqlColorAttributes) => {
  return gqlColorAttributes?.reduce(
    (prev, { colorId, careAndContent } = {}) => {
      if (colorId && careAndContent) {
        return {
          ...prev,
          [colorId]: {
            careAndContent: {
              ...careAndContent,
              id: "careAndContent",
            },
          },
        };
      }

      return prev;
    },
    {}
  );
};

export default colorAttributesTransform;
